import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bell",
  "use": "icon-bell-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bell\"><path d=\"M832 720a48 48 0 0 1-48-48V352c0-123.712-100.288-224-224-224a48 48 0 1 0-96 0c-123.712 0-224 100.288-224 224v320c0 26.512-21.488 48-48 48a48 48 0 1 0 0 96h640a48 48 0 1 0 0-96zM512 960a96 96 0 0 0 96-96H416a96 96 0 0 0 96 96z\" p-id=\"18683\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol